import React, { useContext, useState } from "react";

//Package Imports

import {
  Typography,
  Box,
  useTheme,
  Button,
  Grid,
  Avatar,
  IconButton,
  Paper,
  Tooltip,
  Menu,
  MenuItem,
  Snackbar,
  Alert,
  Modal,
  Switch,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Edit as EditIcon } from "@mui/icons-material";
import DelModal from "../../PouAdminPortal/Setting/DelModal/index";

//user imports

import {
  ProfileIcon,
  DomainIcon,
  EmailIcon,
  PhoneNumberIcon,
  DotsIcon,
  EmailActive,
  EmailInactive,
} from "../../../Svg";
import { RoutesUrls, pouRoutes } from "../../../Services/Routes/APP";
import { hospital_Context } from "../../../context";
import EditNameModal from "./EditName";
import EditPhoneModal from "./EditPhone";
import { useDecodedToken } from "../../../Services/Routes/APP/PrivateRoute";
import { headersPost } from "../../../Services/API/index";
import { MINISTRY_API_ULRS } from "../../../Services/Routes/API";

//component

const Setting = () => {
  //hooks

  const theme = useTheme();
  const navigate = useNavigate();
  const user = useDecodedToken();

  //states

  const [nameOpen, setNameOpen] = useState(false);
  const [phoneOpen, setPhoneOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMsg, setAlertMsg] = useState("");
  const [alertIcon, setAlertIcon] = useState("error");
  const [openModal, setOpenModal] = useState(false);
  const [usersModalOpen, setUsersModalOpen] = useState(false);
  const [checked, setChecked] = useState(false);
  const [statusValue, setStatusValue] = useState(false);

  const expiryNotificationHandler = (value) => {
    const data = {
      expire_batch_notification: value,
    };

    headersPost(MINISTRY_API_ULRS.UPDATE_USER, data)
      .then((res) => {
        if (res?.status === 200 && res?.data?.success) {
          setStatusValue(res?.data?.user?.expire_batch_notification);
        } else {
        }
      })
      .catch((err) => {
        const { response } = err;
        if (response?.status === 401) {
          localStorage.clear();
          navigate(RoutesUrls?.root);
        } else {
        }
      });
    return value;
  };

  const closeModalHandler = () => {
    setOpenModal(false);
  };
  const delProduct = (value) => {
    setChecked(value);
    setOpenModal(true);
  };
  const handleChange = (event) => {
    setChecked(event.target.checked);
  };

  //Navigation Function
  const handleAlertClose = () => {
    setAlertOpen(false);
    setAlertMsg("");
    setAlertIcon("error");
  };
  const usersHandlerClose = () => {
    setUsersModalOpen(false);
  };

  const addHandler = () => {
    navigate(RoutesUrls.pouAdmin + pouRoutes.changePassword);
  };

  //name change handler

  const changeNameHandler = () => {
    setNameOpen(true);
  };

  //name modal close handler

  const closeNameHandler = () => {
    setNameOpen(false);
  };

  //phone change handler

  const changePhoneHandler = () => {
    setPhoneOpen(true);
  };

  //phone modal close handler

  const closePhoneHandler = () => {
    setPhoneOpen(false);
  };

  //render

  return (
    <>
      <Box mt={2}>
        {/* <Grid container>
        <Grid item sm={12} xs={12} md={6} lg={3} paddingLeft={8}>
          <Avatar
            sx={{
              width: 110,
              height: 110,
            }}
          ></Avatar>
        </Grid>
        <Grid item sm={12} xs={12} md={6} lg={3}>
          <Box
            display={"flex"}
            justifyContent={"flex-start"}
            ml={{ xs: 6, sm: 6, md: 1, lg: 1, xl: 1 }}
          >
            <Button
              variant="contained"
              size="large"
              sx={{
                bgcolor: "#435CFF",
                borderRadius: 2,
                mt: 4,
              }}
            >
              Upload Profile
            </Button>
          </Box>
        </Grid>
      </Grid> */}

        <Grid container mt={0.1} pl={{ xs: 1, sm: 2, md: 4 }} spacing={5}>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Grid container>
              <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
                <Box
                  height={60}
                  width={60}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  sx={{
                    backgroundColor: `${theme.palette.secondary.dark}`,
                    borderRadius: 1.5,
                  }}
                >
                  <ProfileIcon />
                </Box>
              </Grid>
              <Grid
                item
                xs={6}
                sm={6}
                md={8}
                lg={8}
                xl={8}
                display={"flex"}
                justifyContent={"start"}
              >
                <Box
                  display={"flex"}
                  flexDirection={"column"}
                  justifyContent={"center"}
                >
                  <Typography variant="h6" color={"GrayText"}>
                    Name
                  </Typography>
                  <Typography variant="p">{user?.name}</Typography>
                </Box>
              </Grid>
              <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                <Box
                  height={55}
                  width={55}
                  ml={{ xs: theme.spacing(-1.2), sm: 0 }}
                  sx={{
                    backgroundColor: theme.palette.secondary.main,
                    ":hover": {
                      backgroundColor: theme.palette.secondary.main,
                    },
                  }}
                  onClick={changeNameHandler}
                  component={IconButton}
                >
                   <Tooltip title="Edit">
                      <EditIcon
                        sx={{
                          color: theme.palette.common.white,
                        }}
                      />
                    </Tooltip>
                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Grid container paddingRight={2}>
              <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
                <Box
                  height={60}
                  width={60}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  sx={{
                    backgroundColor: `${theme.palette.secondary.dark}`,
                    borderRadius: 1.5,
                  }}
                >
                  <EmailIcon />
                </Box>
              </Grid>
              <Grid
                item
                xs={6}
                sm={6}
                md={8}
                lg={8}
                xl={8}
                display={"flex"}
                justifyContent={"start"}
              >
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  flexDirection={"column"}
                >
                  <Typography variant="h6" color={"GrayText"}>
                    E-mail
                  </Typography>
                  <Typography variant="p">{user?.email} </Typography>
                </Box>
              </Grid>
              <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
              <Tooltip title="Actions"  >
                    <Button
                      variant="none"

                      onClick={() => delProduct(statusValue ? false : true)}
                      size="small"
                      sx={{ ml: { xs: -1, sm: -1 },  height:"22px", borderRadius: theme.spacing(2) , padding: theme.spacing(0) }}

                    >
                      {statusValue ? <EmailInactive  /> : <EmailActive   />}
                    </Button>
                  </Tooltip>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid container mt={0.1} pl={{ xs: 1, sm: 2, md: 4 }} spacing={5}>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Grid container>
              <Grid item xs={4} sm={4} md={2} lg={2} xl={2}>
                <Box
                  height={60}
                  width={60}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  sx={{
                    backgroundColor: `${theme.palette.secondary.dark}`,
                    borderRadius: 1.5,
                  }}
                >
                  <DomainIcon />
                </Box>
              </Grid>
              <Grid
                item
                xs={6}
                sm={6}
                md={8}
                lg={8}
                xl={8}
                display={"flex"}
                justifyContent={"start"}
              >
                <Box
                  display={"flex"}
                  justifyContent={"center"}
                  flexDirection={"column"}
                >
                  <Typography variant="h6" color={"GrayText"}>
                    Domain
                  </Typography>
                  <Typography variant="p" noWrap>
                    {user?.domain}
                  </Typography>
                </Box>
              </Grid>
              <Grid
                item
                xs={2}
                sm={2}
                md={2}
                lg={2}
                xl={2}
                display={"flex"}
                justifyContent={"start"}
              ></Grid>
            </Grid>
          </Grid>

          {/* <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
            <Grid container>
              <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                <Box
                  height={60}
                  width={60}
                  display={"flex"}
                  alignItems={"center"}
                  justifyContent={"center"}
                  sx={{
                    backgroundColor: `${theme.palette.secondary.dark}`,
                    borderRadius: 1.5,
                  }}
                >
                  <PhoneNumberIcon />
                </Box>
              </Grid>
              <Grid item xs={8} sm={8} md={8} lg={8} xl={8}>
                <Box>
                  <Typography variant="p" color={"GrayText"} noWrap>
                    Phone Number
                  </Typography>
                  <Typography variant="h6" noWrap>
                    {user?.phone_number}
                  </Typography>
                </Box>
              </Grid>

              <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                <Box
                  height={55}
                  width={55}
                  sx={{
                    backgroundColor: theme.palette.secondary.main,
                    ":hover": {
                      backgroundColor: theme.palette.secondary.main,
                    },
                  }}
                  onClick={changePhoneHandler}
                  component={IconButton}
                >
                  <EditIcon
                    sx={{
                      color: theme.palette.common.white,
                    }}
                  />
                </Box>
              </Grid>
            </Grid>
          </Grid> */}
        </Grid>

        <Box padding={{ xs: 2, sm: 3, md: 4 }}>
          <Typography variant="h4">Privacy &amp; Security</Typography>
          <Button
            variant="contained"
            size="large"
            onClick={addHandler}
            sx={{
              bgcolor: "#435CFF",
              borderRadius: 2,
              mt: 4,
            }}
          >
            Change Password
          </Button>
        </Box>

        <EditNameModal
          open={nameOpen}
          closeHandler={closeNameHandler}
          user={user}
        />
        <EditPhoneModal
          open={phoneOpen}
          closeHandler={closePhoneHandler}
          user={user}
        />
      </Box>
      <DelModal
        status={checked}
        open={openModal}
        handleClose={closeModalHandler}
        expiryNotificationHandler={expiryNotificationHandler}
      />

      <Snackbar
        open={alertOpen}
        autoHideDuration={6000}
        onClose={handleAlertClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleAlertClose} severity={alertIcon}>
          {alertMsg}
        </Alert>
      </Snackbar>
    </>
  );
};

export default Setting;
